export const careevaDesignSystem = {
  modes: {
    quick: {
      label: 'Simple',
      promise: 'Нажал пару кнопок и забыл',
      density: 'low',
      maxPrimaryActions: 4,
      navigationDepth: 1,
      explanation: 'AI сам выбирает стратегию, показывает только следующий лучший шаг.'
    },
    advanced: {
      label: 'Advanced',
      promise: 'Контролируемая автоматизация',
      density: 'medium',
      maxPrimaryActions: 6,
      navigationDepth: 2,
      explanation: 'Пользователь управляет фильтрами, CV версиями, правилами поиска и approval queue.'
    },
    pro: {
      label: 'Pro',
      promise: 'Полная видимость оркестрации',
      density: 'high',
      maxPrimaryActions: 9,
      navigationDepth: 2,
      explanation: 'Доступны AI inspector, pipeline logic, scoring, quality, trust и системные состояния.'
    }
  },
  tokens: {
    color: {
      bg: '#0B0F14',
      surface: '#111827',
      surfaceRaised: '#161B22',
      border: 'rgba(148, 163, 184, .18)',
      text: '#E5EEF9',
      muted: '#8EA0B8',
      ai: '#8B5CF6',
      action: '#38BDF8',
      success: '#34D399',
      warning: '#FBBF24',
      danger: '#FB7185'
    },
    radius: { card: 24, control: 16, pill: 999 },
    spacing: { xs: 6, sm: 10, md: 16, lg: 24, xl: 36 },
    typography: {
      family: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
      display: 'clamp(28px, 5vw, 56px)',
      title: 'clamp(20px, 3vw, 32px)',
      body: '15px',
      meta: '12px'
    },
    motion: {
      fast: '120ms ease-out',
      normal: '220ms ease-out',
      slow: '420ms cubic-bezier(.2,.8,.2,1)'
    }
  },
  aiLanguage: {
    thinking: 'Careeva анализирует сигналы…',
    ranking: 'AI ранжирует варианты по match, growth, risk и effort.',
    askingApproval: 'Нужен approve перед действием.',
    done: 'Готово. Следующий лучший шаг обновлён.',
    fallback: 'Работаю в безопасном fallback-режиме без внешнего LLM.',
    blocked: 'Действие заблокировано правилом доверия или качеством данных.'
  },
  stateModel: [
    ['idle', 'Система ждёт действия', 'muted'],
    ['thinking', 'AI анализирует данные', 'ai'],
    ['queued', 'Задача поставлена в очередь', 'warning'],
    ['needs_approval', 'Нужен быстрый approve', 'action'],
    ['running', 'Выполняется автоматизация', 'ai'],
    ['done', 'Действие завершено', 'success'],
    ['risk', 'Есть риск или недостаток данных', 'danger'],
    ['fallback', 'Используется локальная безопасная логика', 'warning']
  ],
  navigation: {
    global: ['Home', 'AI', 'Jobs', 'Planner/Pipeline', 'Profile/CV'],
    career: {
      Home: ['Daily Mission', 'Next Best Action', 'Career Velocity'],
      Jobs: ['Opportunity Stream', 'Review Queue', 'Search Rules'],
      CV: ['Active CV', 'Versions', 'Optimizer', 'Parsing Events'],
      AI: ['Automation Rules', 'Command Center', 'AI Inspector', 'Quality Lab'],
      Chat: ['Recruiter Threads', 'Trust Signals', 'Reply Drafts']
    },
    recruiter: {
      Home: ['Hiring Mission', 'Calendar', 'Urgent Tasks'],
      Jobs: ['Vacancies', 'Search Settings', 'Candidates'],
      Pipeline: ['Stages', 'Bottlenecks', 'Offers'],
      AI: ['Automation', 'Quality', 'Trust', 'Commands'],
      Chat: ['Candidate Threads', 'Risk', 'Follow-ups']
    }
  },
  commandModel: [
    'Найди remote AI вакансии в Германии с match > 90',
    'Адаптируй CV под первую вакансию',
    'Покажи почему эта вакансия подходит',
    'Составь план поиска на 7 дней',
    'Ответь рекрутеру коротко и уверенно',
    'Покажи все действия, которые требуют approve'
  ]
};

export const miniAppFirstFlows = [
  {
    id: 'quick-apply',
    name: 'Quick Apply Approval',
    mode: 'quick',
    steps: ['Telegram notification', 'Open MiniApp', 'Review AI summary', 'Approve / Review', 'Done'],
    targetClicks: 2
  },
  {
    id: 'cv-improve',
    name: 'Improve CV for top match',
    mode: 'advanced',
    steps: ['Open CV', 'See missing signals', 'Apply AI suggestion', 'Save version', 'Queue apply'],
    targetClicks: 4
  },
  {
    id: 'pro-orchestration',
    name: 'Professional orchestration review',
    mode: 'pro',
    steps: ['Command palette', 'Inspect scoring', 'Adjust rules', 'Run queue', 'Monitor quality'],
    targetClicks: 5
  }
];

export const componentHierarchy = [
  ['Shell', 'App frame, Telegram/browser responsive container'],
  ['Command Layer', 'Global input, suggestions, approval commands, shortcuts'],
  ['Action Stack', 'Primary next actions, max 4 in Simple mode'],
  ['Entity Cards', 'Jobs, CVs, candidates, chats, tasks'],
  ['Inspector Drawer', 'Why matched, risks, confidence, raw scoring'],
  ['State Rail', 'AI status, queue, fallback, trust, errors'],
  ['System Panels', 'Quality, data sources, reset, telemetry']
];
